<section class="image-dialog">
  <span class="image-dialog__close" (click)="close()">
    <i class="iconsax image-dialog__close-icon" icon-name="x"></i>
  </span>
  <img [src]="src" />
</section>
